import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

import '../assets/styles/Main.scss';
import me from "../assets/images/me.jpeg"

function Main() {

  

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={me} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/LuisDeLeon24" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/luis-de-le%C3%B3n-1a6a32331/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Luis De León</h1>
          <p>Fullstack Developer | Cybersecurity Enthusiast | AI Solutions</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/LuisDeLeon24" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/luis-de-le%C3%B3n-1a6a32331/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;